import React from 'react';
import classNames from 'classnames';
import { ListItemControlButtons, IListItemControlButtonsProps } from './ListItemControlButtons';
import './ListItem.less';

export interface IListItemProps extends IListItemControlButtonsProps {
  className?: string;
  label: string;
  hint?: string;
  render?: (index: number) => React.ReactNode;
}

export const LIST_ITEM_CLASS_NAME = 'dpc-list-item';
const getClassName = (className?: string) => classNames(LIST_ITEM_CLASS_NAME, className);

/**
 * List Item can be removed.
 *
 * TODO this name seems confusingly generic...
 *
 * Copyright (c) 2019 Decisions All Rights Reserved
 */
export function ListItem(props: IListItemProps) {
  const { className, index, label, hint, render } = props;

  return (
    <li className={getClassName(className)}>
      {!render && (
        <span className={`${LIST_ITEM_CLASS_NAME}__title`} title={hint || label}>
          {label}
        </span>
      )}
      {render && render(index)}
      <ListItemControlButtons {...props} />
    </li>
  );
}
